import { useState, useEffect } from 'react';

const useNormalizedReviewData = ({ reviews, ratingDistribution, recommended }) => {
  const [recommendedStore, setRecommendedStore] = useState(recommended);
  const [ratingDistributionStore, setRatingDistribution] = useState(ratingDistribution);
  const [hasReviews, setHasReviews] = useState(false);

  useEffect(() => {
    setRatingDistribution(ratingDistribution);
    recommended && setRecommendedStore(recommended);
    setHasReviews(reviews.length > 0);
  }, [reviews]);

  return { recommendedStore, ratingDistributionStore: ratingDistributionStore, hasReviews };
};

export default useNormalizedReviewData;
export { useNormalizedReviewData };
